import { emitEventV2 } from "../../util/url";

export interface IErrorLog {
  type: "SYSTEM";
  severity: "LOG" | "EXCEPTION" | "CRASH";
  event_name:
    | "API_SUCCESS"
    | "API_ERROR"
    | "MALFORMED_API_RESPONSE_ERROR"
    | "INTERNAL_ERROR"
    | "INITILIZATION_ERROR"
    | "UNKNOWN_ERROR";
  event_id: string;
  event_source: "EUI";
  eui_url: string;
  user_id: string;
  timestamp: string;
  analytics_version: "4.0.0";
  fe_version: string;
  build_version?: string;
  session_id: string;
  session_time: number; // in milliseconds
  campaign_id?: string | "not_available";
  client_id?: string;
  code: number | string;
  message: string;
  stack_trace: string;
  platform_details: {
    device_type: string;
    os: string;
    agent_type: string;
    app_platform: string;
  };
  api_request: any;
  api_response: any;
  router_state: any;
  error_page: any;
  function_arguments: any;
  function_name: any;
}

export async function sendErrorLog(errorLog: IErrorLog) {
  try {
    if (window["_SL"]) {
      window["Sentry"].captureException(errorLog);
    } else {
      loadSentryScript()
        .then(() => {
          window["Sentry"].captureException(errorLog);
        })
        .catch((e) => console.log(e));
    }
  } catch (e) {
    console.log(e);
  }
}

function loadSentryScript(): Promise<void> {
  return new Promise((resolve, reject) => {
    // Check if the script is already loaded
    if (window["_SL"]) {
      resolve();
      return;
    }

    // Create a new script element
    const scriptElement = document.createElement("script");
    scriptElement.src =
      "https://js.sentry-cdn.com/4f619a9730114afe9d54092f7f888f56.min.js";
    scriptElement.crossOrigin = "anonymous";

    // Attach event handlers to determine when the script has loaded, or if an error occurs
    scriptElement.onload = () => {
      window["_SL"] = true;
      resolve();
    };
    scriptElement.onerror = (error) => {
      reject(
        new Error(`Failed to load the Sentry script: ${error["message"]}`)
      );
    };

    // Append the script to the document's head
    document.head.appendChild(scriptElement);
  });
}
